/* AWA thank-you pop-up (CLAUDE DRAFT). window.AWAThanks.show({ title, text }) from any form; also shows automatically
   after Shopify contact/newsletter forms reload the page (?contact_posted=true / ?customer_posted=true). */
(function () {
  var root, box, cfg = {}, lastFocus, defTitle, defText;
  function esc(v) { return String(v || '').replace(/([,;\\])/g, '\\$1'); }
  function vcard() {
    var lines = ['BEGIN:VCARD', 'VERSION:3.0', 'FN:' + esc(cfg.name), 'ORG:' + esc(cfg.name)];
    if (cfg.phone) lines.push('TEL;TYPE=WORK,VOICE:' + cfg.phone.replace(/\s+/g, ''));
    if (cfg.email) lines.push('EMAIL;TYPE=WORK:' + cfg.email);
    if (cfg.street || cfg.suburb) lines.push('ADR;TYPE=WORK:;;' + esc(cfg.street) + ';' + esc(cfg.suburb) + ';' + esc(cfg.state) + ';' + esc(cfg.postcode) + ';Australia');
    if (cfg.web) lines.push('URL:' + cfg.web);
    lines.push('END:VCARD');
    var blob = new Blob([lines.join('\r\n') + '\r\n'], { type: 'text/vcard;charset=utf-8' });
    var a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = 'Airconditioning-Wholesale-Australia.vcf';
    document.body.appendChild(a); a.click(); setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
  }
  function show(opts) {
    if (!root) return;
    opts = opts || {};
    root.querySelector('[data-ty-title]').textContent = opts.title || defTitle;
    root.querySelector('[data-ty-text]').textContent = opts.text || defText;
    lastFocus = document.activeElement;
    root.hidden = false; requestAnimationFrame(function () { root.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden'; box.focus();
  }
  function close() {
    if (!root || root.hidden) return;
    root.classList.remove('is-open'); document.documentElement.style.overflow = '';
    setTimeout(function () { root.hidden = true; }, 220); if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function init() {
    root = document.querySelector('[data-awa-ty]'); if (!root) return;
    document.body.appendChild(root); box = root.querySelector('.awa-ty__box');
    try { cfg = JSON.parse(document.querySelector('[data-ty-config]').textContent); } catch (e) {}
    defTitle = root.querySelector('[data-ty-title]').textContent; defText = root.querySelector('[data-ty-text]').textContent;
    root.querySelectorAll('[data-ty-close]').forEach(function (c) { c.addEventListener('click', close); });
    root.querySelector('[data-ty-vcard]').addEventListener('click', vcard);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    var q = location.search;
    if (/[?&]contact_posted=true/.test(q)) show();
    else if (/[?&]customer_posted=true/.test(q)) show({ title: cfg.newsTitle, text: cfg.newsText });
  }
  window.AWAThanks = { show: function (o) { if (root) show(o); else document.addEventListener('DOMContentLoaded', function () { show(o); }); }, close: close };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();